import { titleStyles as styles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsTitle";

styles.titleText = {
    ...styles.titleText,
    variant: "h1",
};
